import { render, staticRenderFns } from "./CardTarjaEnqueteCopaTVFechadaWithQRCode.vue?vue&type=template&id=241b40d6&scoped=true"
import script from "./CardTarjaEnqueteCopaTVFechadaWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteCopaTVFechadaWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteCopaTVFechadaWithQRCode.vue?vue&type=style&index=0&id=241b40d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b40d6",
  null
  
)

export default component.exports